import axios from 'axios';
import { itemToOptions } from '../../components/utils/GlobalFunctions.js';
import {
  getStepFunctionStatus,
  processTableID,
  processingStepFunctionStatus,
  showAnalysisModal,
  showLoader,
  toggleAlertMessage,
} from '../action.js';
import createSignedRequest from './createSignedRequest';
import { Actions as ORGANISATION_ACTIONS } from './organisationActions';
import { updateDownloadStatus } from './reportActions.js';

const { apiURL } = require('./apiURL');

const Types = {
  MODAL: 'ADMIN_PROFILE_MODAL',
  ADMIN_GETTING: 'ADMIN_GETTING',
  ADMIN_ORGANISATIONS: 'ADMIN_ORGANISATIONS',
  ADMIN_GET_CONVERSION_FACTORS: 'ADMIN_GET_CONVERSION_FACTORS',
  ADMIN_GET_ALL_ITEMS: 'ADMIN_GET_ALL_ITEMS',
  SHOW_UPLOAD_LOGO_MODAL: 'ADMIN_SHOW_UPLOAD_LOGO_MODAL',
  ADMIN_SAVE_CONVERSION_FACTOR: 'ADMIN_SAVE_CONVERSION_FACTOR',
  ADMIN_UPDATE_CONVERSION_FACTOR: 'ADMIN_UPDATE_CONVERSION_FACTOR',
  ADMIN_SET_CHECKBOXES: 'ADMIN_SET_CHECKBOXES',
  ADMIN_UPDATE_ENTITY_BOX: 'ADMIN_UPDATE_ENTITY_BOX',
  ADMIN_UPDATE_USAGE_TOTAL_BOX: 'ADMIN_UPDATE_USAGE_TOTAL_BOX',
  ADMIN_UPDATE_USAGE_DATA_BOX: 'ADMIN_UPDATE_USAGE_DATA_BOX',
  ADMIN_EXPORT_USAGE_DATA: 'ADMIN_EXPORT_USAGE_DATA',
  ADMIN_SUBMIT_BULK_USAGE_DATA: 'ADMIN_SUBMIT_BULK_USAGE_DATA',
  ADMIN_SET_USAGE_BULK_SELECTION_FROM_IDS: 'ADMIN_SET_USAGE_BULK_SELECTION_FROM_IDS',
  ADMIN_PAYMENT_ORGANISATION: 'ADMIN_PAYMENT_ORGANISATION',
  ADMIN_UPDATE_STEP_FUNCTION_STATUS: 'ADMIN_UPDATE_STEP_FUNCTION_STATUS',
  ADMIN_INDEX_RANGE_ITEMS: 'ADMIN_INDEX_RANGE_ITEMS',
  ADMIN_INDEX_TERMS_ITEMS: 'ADMIN_INDEX_TERMS_ITEMS',
  ADD_OR_UPDATE_ADMIN_PORTAL_ITEMS: 'ADMIN_ADD_OR_UPDATE_ADMIN_PORTAL_ITEMS',
  DELETE_ADMIN_PORTAL_ITEMS: 'ADMIN_DELETE_ADMIN_PORTAL_ITEMS',
  ADMIN_UPDATE_CHECKED_ITEMS: 'ADMIN_UPDATE_CHECKED_ITEMS',
  ADMIN_TOGGLE_SELECT_ALL_CHECKED: 'ADMIN_TOGGLE_SELECT_ALL_CHECKED',
  ADMIN_SET_OS_TERMS: 'ADMIN_SET_OS_TERMS',
  ADMIN_BRANDING_ASSET_PREVIEW_SET: 'ADMIN_BRANDING_ASSET_PREVIEW_SET',
  ADMIN_BRANDING_ASSET_PREVIEW_CLEAR: 'ADMIN_BRANDING_ASSET_PREVIEW_CLEAR',
  ADMIN_BRANDING_ASSET_PREVIEW_REPLACE: 'ADMIN_BRANDING_ASSET_PREVIEW_REPLACE',
};

const updateCheckedItems = (itemID) => ({
  type: Types.ADMIN_UPDATE_CHECKED_ITEMS,
  payload: { itemID },
});

const toggleSelectAllChecked = (checked) => ({
  type: Types.ADMIN_TOGGLE_SELECT_ALL_CHECKED,
  payload: { checked },
});

const setOpenSearchTerms = (openSearchTerms) => ({ type: Types.ADMIN_SET_OS_TERMS, payload: openSearchTerms });

export const toggleModal = (status, action, item, notAutoClose, openSearchTerms) => ({
  type: Types.MODAL,
  status,
  action,
  item,
  notAutoClose,
  openSearchTerms,
});

const initializeCheckBoxes = () => ({
  type: Types.ADMIN_SET_CHECKBOXES,
});

const updateEntityCheckBox = (entity) => ({
  type: Types.ADMIN_UPDATE_ENTITY_BOX,
  entity: entity,
});

const submitBulkEditForEntity = (entity) => ({
  type: Types.ADMIN_SUBMIT_BULK_USAGE_DATA,
  entity: entity,
});

const setUsageBulkSelectionForEntity = (entity, selectedIds) => ({
  type: Types.ADMIN_SET_USAGE_BULK_SELECTION_FROM_IDS,
  entity,
  selectedIds,
});

const updateUsageTotalCheckBox = (usageTotalId) => ({
  type: Types.ADMIN_UPDATE_USAGE_TOTAL_BOX,
  usageTotalId: usageTotalId,
});

const updateUsageDataCheckBox = (usageItem) => ({
  type: Types.ADMIN_UPDATE_USAGE_DATA_BOX,
  usageItem: usageItem,
});

const updateAdminOrganisations = (response) => ({
  type: Types.ADMIN_ORGANISATIONS,
  payload: response,
});

export const getAdminOrganisations = (options = {}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { cyfAdmin, consultantAdmin } = state.profile.details || {};
    const { includeAll = false } = options;

    let path;
    if (consultantAdmin) {
      path = '/my/admin/organisations?includeAll=true';
    } else if (cyfAdmin) {
      path = `/my/admin/organisations${includeAll ? '?includeAll=true' : ''}`;
    } else {
      path = '/my/whitelabel/organisations';
    }

    try {
      const response = await axios(await createSignedRequest('GET', apiURL + path, null));

      console.log('getAdminOrganisations', response);
      dispatch(updateAdminOrganisations(response.data));
    } catch (e) {
      console.log('getAdminOrganisations Error:', e);
    }
  };
};

export const adminPortalItems = (response, table) => ({
  type: Types.ADMIN_GET_ALL_ITEMS,
  payload: response,
  table,
});

export const updateDefaultValues = (type) => {
  //Used for Usage Type Labels Modal
  return async (dispatch, getState) => {
    const state = getState();
    //get all values from usageTypes tables and filter based on type
    const usageTypes = state?.admin?.adminPortal?.usageTypes;
    const usageTypeFiltered = usageTypes?.filter((ut) => ut?.type === type);
    usageTypeFiltered?.map(itemToOptions);
    dispatch(adminPortalItems({ items: usageTypeFiltered }, 'defaultValues'));
  };
};

export const getAllItemsFromDB = (table, filter, force = false) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { consultantAdmin, whiteLabelAdmin } = state.profile?.details;

    let endPoint;
    if (whiteLabelAdmin) endPoint = `/admin/portal/whiteLabelAdmin/${table}`;
    else if (consultantAdmin) endPoint = `/admin/portal/consultantAdmin/${table}`;
    else endPoint = `/admin/portal/${table}${filter ? `?page=${filter.page}&size=${filter.size}` : ''}`;

    const cache = state.admin?.adminPortal?.[table] || {};
    try {
      if (force || !cache?.length) {
        dispatch(showLoader(true));
        const response = await axios(
          await createSignedRequest('GET', apiURL + endPoint, null, { Organisation: String(state.currentOrganisation) })
        );

        console.log('getAllItemsFromDB', response.data);
        dispatch(adminPortalItems(response.data, table));
        dispatch(showLoader(false));
        return response;
      }

      console.log('getAllItemsFromDB (cached)', { items: cache, table, itemCount: cache.length });
    } catch (e) {
      dispatch(showLoader(false));
      console.log('getAllItemsFromDB Error:', e);
    }
  };
};

export const getTemplates = () => {
  return async (dispatch, getState) => {
    dispatch(showLoader(true));

    try {
      const response = await axios(await createSignedRequest('GET', apiURL + `/admin/templates`));

      dispatch(adminPortalItems(response.data, 'templates'));
      dispatch(showLoader(false));
      return response.data;
    } catch (error) {
      dispatch(showLoader(false));
      console.error('Error:', error);
    }
  };
};

export const toggleTemplate = (template) => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader(true));

    try {
      const response = await axios(
        await createSignedRequest('POST', apiURL + `/admin/templates/toggle`, JSON.stringify({ id: template.id }))
      );

      const templates = state?.admin?.adminPortal?.templates;

      const versions = templates?.find((t) => t.value === template.templateType)?.versions;
      response.data.forEach((updatedItem) => {
        const index = versions.findIndex((item) => item.id === updatedItem.id);
        if (index !== -1) versions[index] = { ...versions[index], ...updatedItem };
      });

      dispatch(adminPortalItems({ items: templates }, 'templates'));
      dispatch(showLoader(false));
      return templates;
    } catch (error) {
      dispatch(showLoader(false));
      console.error('Error:', error);
    }
  };
};

export const generateNewTemplate = (templateType) => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader(true));

    try {
      const response = await axios(
        await createSignedRequest('POST', apiURL + `/admin/templates`, JSON.stringify({ templateType }))
      );

      const templates = state?.admin?.adminPortal?.templates;
      templates?.find((t) => t.value === templateType)?.versions?.unshift(response.data);

      dispatch(adminPortalItems({ items: templates }, 'templates'));
      dispatch(showLoader(false));
      return templates;
    } catch (error) {
      dispatch(showLoader(false));
      console.error('Error:', error);
    }
  };
};

const addOrUpdateAdminPortalItems = (item, table, id) => ({
  type: Types.ADD_OR_UPDATE_ADMIN_PORTAL_ITEMS,
  item,
  table,
  id,
});

const updateOrAddToDB = (table, item) => {
  return async (dispatch, getState) => {
    const state = getState();

    console.log('ITEM', item);

    // Mapping conversionFactor data to keep null values.
    if (table === 'conversionFactors') {
      item = item.map((o) => {
        return {
          id: o?.id?.toString() || null,
          ch4: o?.ch4 || '0.00',
          co2: o?.co2 || '0.00',
          co2e: o?.co2e || '0.00',
          fuel: o?.fuel || null,
          load: o?.load || null,
          price: o?.price || null,
          originlocation: o?.originlocation || null,
          finallocation: o?.finallocation || null,
          factorprovider: o?.factorprovider || null,
          metric: o?.metric,
          n2o: o?.n2o || '0.00',
          production: o?.production || null,
          scope: o?.scope,
          seat: o?.seat || null,
          subentity: o?.subentity,
          vehicle: o?.vehicle || null,
          waste: o?.waste || null,
          wtt: o?.wtt || '0.00',
          year: o?.year,
          outsideOfScopes: o?.outsideOfScopes || '0.00',
          source: o?.source || null,
          notes: o?.notes || null,
          addOns: o?.addOns || null,
          creationDate: o?.id ? o?.creationDate : new Date().toString(),
          modificationDate: new Date().toString(),
          discontinuedDate: o?.discontinuedDate || null,
          userId: state?.profile?.details?.id || null,
        };
      });
    }

    /*
    if (table === 'marketFactors') {
      item = item.map((o) => {
        return {
          id: o?.id?.toString() || null,
          factorSource: o?.factorSource || null,
          kgco2e: o?.kgco2e || null,
          kgco2eWTT: o?.kgco2eWTT || null,
          subentity: o?.subentity || null,
          TDWTT: o?.TDWTT || null,
          TD: o?.TD || null,
          year: o?.year || null,
          outsideOfScopes: o?.outsideOfScopes || null,
          radioactiveWaste: o?.radioactiveWaste || null,
          renewable: o?.renewable || null,
          source: o?.source || null,
          creationDate: o?.id ? o?.creationDate : formatISO(new Date()),
          modificationDate: formatISO(new Date()),
          price: o?.price || null,
          originlocation: o?.originlocation || null,
          finallocation: o?.finallocation || null,
          factorprovider: o?.factorprovider || null,
        };
      });
    } */

    if (table === 'integrationMappings') {
      item = item.map((o) => {
        return {
          id: o?.id?.toString() || null,
          entityId: o?.entityId || null,
          subentityId: o?.subentityId || null,
          factorprovider: o?.factorprovider || null,
          finallocation: o?.finallocation || null,
          originlocation: o?.originlocation || null,
          fuel: o?.fuel || null,
          vehicle: o?.vehicle || null,
          load: o?.load || null,
          price: o?.price || null,
          production: o?.production || null,
          seat: o?.seat || null,
          waste: o?.waste || null,
        };
      });
    }

    if (table === 'features') {
      console.log('item', item);
      item = item.map((o) => {
        return {
          id: o?.id?.toString() || null,
          featureKey: o?.featureKey || null,
          name: o?.name || null,
          description: o?.description || null,
          enabledByDefault: o?.enabledByDefault,
          isBeta: o?.isBeta,
          lastModifiedBy: state?.profile?.details?.firstName + ' ' + state?.profile?.details?.lastName,
        };
      });
    }

    try {
      const response = await axios(
        await createSignedRequest('PUT', apiURL + `/admin/portal/${table}`, JSON.stringify(item), {
          Organisation: String(state.currentOrganisation),
        })
      );

      console.log('updateOrAddToDB', response.data);
      const { message, id, success } = response.data || {};

      if (!success && item.length >= 2) {
        dispatch(toggleAlertMessage(true, message, 'error'));
        return;
      } else if (!success) {
        dispatch(toggleAlertMessage(true, response.data.updatedItem.message, 'error'));
        return;
      }

      dispatch(toggleAlertMessage(true, message, 'success'));

      if (table === 'conversionFactors') {
        const { filters, page, tableSize } = state?.admin?.openSearchTerms;
        setTimeout(async () => {
          // This triggers the fetch of the new/edited CF from the CF admin page
          dispatch(getItemsByTermsFromIndex(table, filters, page, tableSize));
        }, 1500);
      } else {
        dispatch(addOrUpdateAdminPortalItems(item, table, id));
      }
    } catch (e) {
      console.log('updateOrAddToDB Error:', e);
    }
  };
};

const toggleCognitoUserStatus = (table, item) => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const response = await axios(
        await createSignedRequest('POST', apiURL + `/admin/portal/${table}/cognitoUser`, JSON.stringify({ item }), {
          Organisation: String(state.currentOrganisation),
        })
      );

      console.log('UserFromCognito', response.data);

      if (!response.data.upatedUserStatus?.success) {
        dispatch(toggleAlertMessage(true, response.data.upatedUserStatus.message, 'error'));
        return;
      }

      dispatch(toggleAlertMessage(true, response.data.upatedUserStatus?.message, 'success'));
      dispatch(getAllItemsFromDB(table));
    } catch (e) {
      console.log('UserFromCognito Error:', e);
    }
  };
};

const deleteAdminPortalItems = (item, table) => ({
  type: Types.DELETE_ADMIN_PORTAL_ITEMS,
  item,
  table,
});

const deleteItemFromDB = (table, items) => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const response = await axios(
        await createSignedRequest('DELETE', apiURL + `/admin/portal/${table}`, JSON.stringify(items), {
          Organisation: String(state.currentOrganisation),
        })
      );

      console.log('deleteItemFromDB', response);

      const { message, success } = response.data || {};

      if (table === 'reports' && !success) {
        // Show message, that the report cannot be deleted
        dispatch(toggleModal(true, 'reports-delete-not-allowed'));
        return;
      } else if (!success) {
        dispatch(toggleAlertMessage(true, message, 'error'));
      } else {
        dispatch(toggleAlertMessage(true, message, 'success'));
      }

      if (table === 'conversionFactors') {
        const { filters, page, tableSize } = state?.admin?.openSearchTerms;
        setTimeout(async () => {
          // This triggers the fetch of the new/edited CF from the CF admin page
          dispatch(getItemsByTermsFromIndex(table, filters, page, tableSize));
        }, 1500);
      } else {
        // Updates the State with the new list of items
        dispatch(deleteAdminPortalItems(items, table));
      }
    } catch (e) {
      console.log('deleteItemsFromDB Error:', e);
    }
  };
};

const getRangeFromIndex = (index, size, from) => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const response = await axios(
        await createSignedRequest('GET', apiURL + `/admin/portal/range/${index}?size=${size}&page=${from}`, null, {
          Organisation: String(state.currentOrganisation),
        })
      );

      console.log('getRangeFromIndex', response);
      dispatch(listItems(response.data.items, index, response.data.totalCount));
    } catch (e) {
      console.log('getRangeFromIndex Error', e);
    }
  };
};

export const listItems = (items, index, totalCount) => ({
  type: Types.ADMIN_INDEX_RANGE_ITEMS,
  items,
  index,
  totalCount,
});

export const getItemsByTermsFromIndex = (index, filters, page, size) => {
  return async (dispatch) => {
    dispatch(showLoader(true));
    const filterToString = JSON.stringify(filters);

    try {
      const response = await axios(
        await createSignedRequest(
          'POST',
          apiURL + `/admin/portal/itemsByTerms/${index}?page=${page}&size=${size}`,
          filterToString,
          null
        )
      );

      console.log('getItemsByTermsFromIndex', response);

      dispatch(listTermsItems(response.data.items, index, response.data.totalCount));
      dispatch(setOpenSearchTerms({ index, filters, page, tableSize: size }));
      dispatch(showLoader(false));
    } catch (e) {
      console.log('getItemsByTermsFromIndex Error', e);
      dispatch(showLoader(false));
    }
  };
};

const getItemsByTermsFromIndexExport = (index, filters, page, size) => {
  return async (dispatch) => {
    dispatch(updateDownloadStatus(true, 'exportUsageData'));
    const filterToString = JSON.stringify(filters);

    try {
      const response = await axios(
        await createSignedRequest(
          'POST',
          apiURL + `/admin/portal/itemsByTerms/${index}${page ? `?page=${page}` : ''}${size ? `&size=${size}` : ''}`,
          filterToString,
          null
        )
      );

      console.log('getItemsByTermsFromIndexExport', response);
      dispatch(getStepFunctionStatus(response.data.data.executionArn));
      dispatch(showLoader(false));
    } catch (e) {
      dispatch(toggleAlertMessage(true, 'There was an error while exporting data!', 'error', 2000));
      console.log('getItemsByTermsFromIndexExport Error', e);
      dispatch(updateDownloadStatus(true, 'exportUsageData'));
    }
  };
};

export const listTermsItems = (items, index, totalCount) => ({
  type: Types.ADMIN_INDEX_TERMS_ITEMS,
  items,
  index,
  totalCount,
});

const updateStepFunctionStatus = (processingReport, status, reportFiletype) => ({
  type: Types.ADMIN_UPDATE_STEP_FUNCTION_STATUS,
  status,
  reportFiletype,
  processingReport,
});

const getAdminReports = (tableName, fileType) => {
  return async (dispatch, getState) => {
    const state = getState();

    dispatch(updateStepFunctionStatus(null, true, fileType));

    try {
      const response = await axios(
        await createSignedRequest('GET', apiURL + `/admin/generateReport/${tableName}`, null, {
          Organisation: String(state.currentOrganisation),
        })
      );

      console.log('getAdminReports', response);
      dispatch(updateStepFunctionStatus(response.data, true, fileType));
    } catch (e) {
      console.log('getAdminReports Error', e);
      dispatch(updateStepFunctionStatus(null, false, fileType));
    }
  };
};

let reportDownloaded = '';
const getAdminReportsStepFunctionStatus = (importArn) => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const response = await axios(
        await createSignedRequest('GET', apiURL + '/my/stepFunctionStatus/' + importArn, null, {
          Organisation: String(state.currentOrganisation),
        })
      );

      dispatch(processingStepFunctionStatus(response.data));

      //Step Function Status is Succeeded
      if (response.data?.data?.status === 'SUCCEEDED') {
        const signedURL = JSON.parse(response.data.data.output);
        const reportType = JSON.parse(response.data.data.input)?.type;
        if (reportDownloaded !== signedURL.signedURL) {
          reportDownloaded = signedURL.signedURL;
          //const popup = window.open(signedURL.signedURL);
          //if (!popup || popup.closed || typeof popup.closed == 'undefined') {
          //alert('Popup Blocker is enabled! Please add this site to your exception list.');
          //}
        }
        dispatch(updateStepFunctionStatus(false, false, reportType));
      }

      //Step Function Status Failed
      if (response.data?.data?.status === 'FAILED') {
        const reportType = JSON.parse(response.data.data.input)?.type;
        dispatch(updateStepFunctionStatus(false, false, reportType));
        alert('Popup Blocker is enabled! Please add this site to your exception list.');
      }
    } catch (e) {
      console.log('getReportStepFunctionStatus Error:', e);
    }
  };
};

const showUploadLogoModal = (status, item) => ({
  type: Types.SHOW_UPLOAD_LOGO_MODAL,
  status,
  item,
});

const paymentOrganistion = (organisationType) => ({
  type: Types.ADMIN_PAYMENT_ORGANISATION,
  organisationType: organisationType,
});

const recalculateUsage = (id) => {
  return async (dispatch, getState) => {
    const state = getState();

    let field;
    if (id === 'recalcAllUsage') {
      field = id;
    } else {
      switch (window.location.pathname.split('/')[2]) {
        case 'organisations':
          field = 'organisation';
          break;
        case 'subEntities':
          field = 'subentity';
          break;
        default:
      }
    }

    try {
      const response = await axios(
        await createSignedRequest(
          'POST',
          apiURL + `/admin/recalculateUsage?field=${field}`,
          id === 'recalcAllUsage' ? '{}' : JSON.stringify({ id }),
          {
            Organisation: String(state.currentOrganisation),
          }
        )
      );

      console.log('recalculateUsage', response);
      if (field === 'recalcAllUsage') {
        const message = 'ALL usage is being recalculated, please check your email in about an hour';
        dispatch(toggleAlertMessage(true, message, 'success', 300000));
      } else {
        dispatch(getStepFunctionStatus(response.data.data.executionArn));
        //dispatch(updateStepFunctionStatus(response.data));
      }
    } catch (e) {
      console.log('recalculateUsage Error', e);
    }
  };
};

const getRecalcUsageStepFunctionStatus = (importArn) => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const response = await axios(
        await createSignedRequest('GET', apiURL + '/my/stepFunctionStatus/' + importArn, null, {
          Organisation: String(state.currentOrganisation),
        })
      );

      dispatch(processingStepFunctionStatus(response.data));

      console.log('response', response.data);

      //Step Function Status is Succeeded
      if (response.data?.data?.status === 'SUCCEEDED') {
        const data = JSON.parse(response.data.data.output);
        console.log('response data', data);
        dispatch(updateStepFunctionStatus({ ...response.data.data, ...data }));
        if (data.message !== 'No usage data to be recalculated!' && data.type === 'recalculate') {
          // Just show the analysis modal when needed
          dispatch(showAnalysisModal(true, 'recalculateUsage'));
          dispatch(toggleAlertMessage(false));
        }
        return;
      }

      //Step Function Status Failed
      if (response.data?.data?.status === 'FAILED') {
        dispatch(toggleAlertMessage(true, 'There was an error while recalculating Usage!', 'success'));
        return;
      }

      dispatch(toggleAlertMessage(true, 'The usage is being recalculated!', 'success', 600000));
    } catch (e) {
      console.log('getReportStepFunctionStatus Error:', e);
    }
  };
};

const transferOrg = (transferObj) => {
  return async (dispatch, getState) => {
    const state = getState();

    dispatch(showLoader(true));

    try {
      const response = await axios(
        await createSignedRequest('POST', apiURL + `/admin/transferPortal`, JSON.stringify({ transferObj }), {
          Organisation: String(state.currentOrganisation),
        })
      );

      console.log('transferOrg', response);

      const { id: tableID, newOrg } = response.data || {};

      const transfPortalParamsObj = { state, dispatch, type: 'transferPortal' };
      await processTableID(tableID, transfPortalParamsObj);

      dispatch(showLoader(false));
      if (newOrg) {
        dispatch(ORGANISATION_ACTIONS.saveTransferredOrg(newOrg));
      }
    } catch (e) {
      console.log('transferOrg Error', e);
      dispatch(toggleAlertMessage(true, e.message, 'error', 2000));
      dispatch(showLoader(false));
    }
  };
};

/**
 * PUT file bytes to S3 presigned URL (unsigned; browser → S3).
 * @param {string} uploadUrl
 * @param {Blob|File} file
 * @param {string} contentType
 */
export const putBrandingFile = async (uploadUrl, file, contentType) => {
  const res = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': contentType },
  });
  if (!res.ok) {
    const msg = `Upload failed (${res.status}). Check S3 CORS for PUT from this origin.`;
    throw new Error(msg);
  }
};

const presignWhiteLabelBranding =
  ({ whiteLabelId, assetType, contentType }) =>
  async (dispatch, getState) => {
    const state = getState();
    const response = await axios(
      await createSignedRequest(
        'POST',
        apiURL + `/admin/portal/whiteLabel/branding/presign`,
        JSON.stringify({ whiteLabelId, assetType, contentType }),
        {
          Organisation: String(state.currentOrganisation),
        },
      ),
    );
    return response.data;
  };

const setBrandingAssetPreview = (partial) => ({
  type: Types.ADMIN_BRANDING_ASSET_PREVIEW_SET,
  payload: partial,
});

const clearBrandingAssetPreview = () => ({
  type: Types.ADMIN_BRANDING_ASSET_PREVIEW_CLEAR,
});

/** @param {Record<string, string|null|undefined>|null} preview */
const replaceBrandingAssetPreview = (preview) => ({
  type: Types.ADMIN_BRANDING_ASSET_PREVIEW_REPLACE,
  payload: preview,
});

const saveWLSettings = (settings) => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const response = await axios(
        await createSignedRequest('POST', apiURL + `/admin/portal/whiteLabelSettings`, JSON.stringify({ settings }), {
          Organisation: String(state.currentOrganisation),
        }),
      );

      console.log('saveWLSettings', response);
      dispatch(toggleAlertMessage(true, response.data.message, 'success', 2000));
      return response.data;
    } catch (e) {
      console.log('saveWLSettings Error', e);
      dispatch(toggleAlertMessage(true, e.message, 'error', 2000));
      throw e;
    }
  };
};

const repackageFactors = (type) => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader(true));

    try {
      const response = await axios(
        await createSignedRequest('POST', apiURL + `/admin/portal/repackage`, JSON.stringify({ type }), {
          Organisation: String(state.currentOrganisation),
        })
      );

      console.log('repackageFactors', response);
      dispatch(toggleAlertMessage(true, response.data.message, 'success', 2000));
      dispatch(showLoader(false));
    } catch (e) {
      console.log('repackageFactors Error', e);
      dispatch(toggleAlertMessage(true, e.message, 'error', 2000));
      dispatch(showLoader(false));
    }
  };
};

const linkStripeAccount = (stripeAccountId, organisationId) => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const response = await axios(
        await createSignedRequest(
          'POST',
          apiURL + `/admin/portal/attachStripeAccount`,
          JSON.stringify({ stripeAccountId, organisationId }),
          {
            Organisation: String(state.currentOrganisation),
          }
        )
      );

      console.log('linkStripeAccount', response);
      dispatch(toggleAlertMessage(true, response.data.message, 'success', 4000));
    } catch (e) {
      console.log('linkStripeAccount Error', e);
      dispatch(toggleAlertMessage(true, e.message, 'error', 5000));
    }
  };
};

const unlinkStripeAccount = (stripeAccountId, organisationId, subEndDate) => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const response = await axios(
        await createSignedRequest(
          'POST',
          apiURL + '/admin/portal/unlinkStripeAccount',
          JSON.stringify({ stripeAccountId, organisationId, subEndDate }),
          {
            Organisation: String(state.currentOrganisation),
          }
        )
      );

      console.log('unlinkStripeAccount', response);
      dispatch(toggleAlertMessage(true, response.data.message, 'success', 4000));
    } catch (e) {
      console.log('unlinkStripeAccount Error', e);
      dispatch(toggleAlertMessage(true, e?.stack, 'error', 5000));
    }
  };
};

const getAuditLogs = (period) => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader(true));

    try {
      const response = await axios(
        await createSignedRequest('GET', apiURL + `/admin/auditLogs?logGroupName=AuditLog&logStreamName=${period}`, null, {
          Organisation: String(state.currentOrganisation),
        })
      );

      dispatch(showLoader(false));
      return response.data;
    } catch (e) {
      dispatch(showLoader(false));
    }
  };
};

export const exportUserTable = () => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const sigRes = await axios(
        await createSignedRequest('GET', apiURL + `/admin/portal/exportUserTable`, null, {
          Organisation: String(state.currentOrganisation),
        })
      );

      const { signedURL, fileName } = sigRes.data;
      if (!signedURL || !fileName) {
        console.error('Missing signedURL or fileName');
        return;
      }

      // Fetch the CSV as a blob
      const downloadRes = await axios.get(signedURL, {
        responseType: 'blob', // ← key: get the raw data
      });

      // Turn it into an object URL & trigger download
      const blob = new Blob([downloadRes.data], { type: 'text/csv' });
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);

      dispatch(toggleAlertMessage(true, 'Exported User Table', 'success', 2000));
    } catch (e) {
      console.log('exportUserTable Error', e);
    }
  };
};

const saveReportTemplate = (template) => {
  return async (dispatch, getState) => {
    dispatch(showLoader(true));
    const state = getState();

    try {
      const response = await axios(
        await createSignedRequest(
          'POST',
          apiURL + '/admin/portal/reportTemplates',
          { template: template },
          {
            Organisation: String(state.currentOrganisation),
          }
        )
      );

      console.log('saveReportTemplate', response);
      dispatch(getAllItemsFromDB('reportTemplates', null, true));
      dispatch(toggleAlertMessage(true, response.data.message, 'success', 4000));
      dispatch(showLoader(false));
    } catch (e) {
      console.log('saveReportTemplate Error', e);
      dispatch(toggleAlertMessage(true, e?.stack, 'error', 5000));
      dispatch(showLoader(false));
    }
  };
};

const Actions = {
  toggleModal,
  getAdminOrganisations,
  getAllItemsFromDB,
  getTemplates,
  toggleTemplate,
  generateNewTemplate,
  updateOrAddToDB,
  toggleCognitoUserStatus,
  showUploadLogoModal,
  deleteItemFromDB,
  initializeCheckBoxes,
  updateEntityCheckBox,
  updateUsageTotalCheckBox,
  updateUsageDataCheckBox,
  submitBulkEditForEntity,
  setUsageBulkSelectionForEntity,
  paymentOrganistion,
  getAdminReports,
  getAdminReportsStepFunctionStatus,
  getRangeFromIndex,
  getItemsByTermsFromIndex,
  getItemsByTermsFromIndexExport,
  recalculateUsage,
  getRecalcUsageStepFunctionStatus,
  transferOrg,
  updateCheckedItems,
  toggleSelectAllChecked,
  setOpenSearchTerms,
  updateDefaultValues,
  saveWLSettings,
  presignWhiteLabelBranding,
  setBrandingAssetPreview,
  clearBrandingAssetPreview,
  replaceBrandingAssetPreview,
  linkStripeAccount,
  unlinkStripeAccount,
  getAuditLogs,
  repackageFactors,
  exportUserTable,
  adminPortalItems,
  saveReportTemplate,
};

export { Actions, Types };
